import { useParams } from 'react-router';
import { usePageNumberFromUrl } from 'idsk-react-components';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import PodporovatelListPage from '../../../model/podporovatel/PodporovatelListPage';
import { fetchPodporovatelListPage } from '../../../client/podporovatelClient';

interface ReturnType {
  podporovatelListPage: PodporovatelListPage;
  podporovatelStatus: ClientStatus;
  podporovatelPageNumberFromUrl: number;
}

export default (): ReturnType => {
  const { page } = usePageNumberFromUrl('page');
  const podporovatelPageNumberFromUrl = page;

  const {
    type, year, index, uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const {
    data: podporovatelListPage,
    status: podporovatelStatus,
  } = useClientFetch(
    fetchPodporovatelListPage,
    [type, year, index, uuid, podporovatelPageNumberFromUrl],
    [page],
  );
  return { podporovatelListPage, podporovatelStatus, podporovatelPageNumberFromUrl };
};
